<template>
  <li class="serp__filter--range-container q-row">
    <div class="serp__filter--range-min q-col-6">
      <small class="q-small">{{ SmartSearchTranslations.filters.from }}</small>
      <div class="q-input-group-sm q-mb-3 q-d-flex q-position-relative" :class="{'q-with-error': !!minError}">

        <input class="serp__filter--range-min-input q-form-control q-p-1  q-p-1 q-text-end "
               :class="{'q-with-unit': !!unit }"
               :data-field="field"
               :id="field + '_min'"
               :name="field + '_min'"
               :placeholder="minInputValue"
               :min="minInputValue"
               type="number"
               autocomplete="off"
               @change="handleMinInputChange($event)"
               @enter.prevent="handleMaxInputChange($event)"
               v-model="minValue">
        <span class="q-error-message q-position-absolute" v-show="minError">{{ minErrorText }}</span>
        <small v-if="unit" class="q-input-group-text q-unit">{{ unit }}</small>
      </div>

    </div>
    <div class="serp__filter--range-max q-col-6">
      <small class="q-small">{{ SmartSearchTranslations.filters.to }}</small>
      <div class="q-input-group-sm q-mb-3 q-d-flex q-position-relative" :class="{'q-with-error': !!maxError}">
        <input class="serp__filter--range-max-input q-form-control q-p-1 q-text-end"
               :class="{'q-with-unit': !!unit}"
               :data-field="field"
               :id="field + '_max'"
               :name="field + '_max'"
               :placeholder="maxInputValue"
               :min="minInputValue"
               type="number"
               autocomplete="off"
               @change="handleMaxInputChange($event)"
               @enter.prevent="handleMaxInputChange($event)"
               v-model="maxValue">
        <span class="q-error-message q-position-absolute" v-show="maxError">{{ maxErrorText }}</span>
        <small v-if="unit" class="q-input-group-text q-unit">{{ unit }}</small>
      </div>
    </div>
  </li>
</template>

<script setup lang="ts">
import {defineProps, ref, inject, defineEmits, onMounted, onUpdated, watch} from 'vue';
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {storeToRefs} from "pinia";
import {SmartSearchTranslationsInterface} from "@/core/types";

const props = defineProps(['filterData', 'field'])
const emit = defineEmits(['closeDropdown', 'minInputChange', 'maxInputChange']);
const filtersStore = useFiltersStore()
const {getActiveFilters} = storeToRefs(filtersStore)

const minValue = ref(null)
const maxValue = ref(null)
const minError = ref(false)
const minErrorText = ref('')
const maxError = ref(false)
const maxErrorText = ref('')
const inputChanging = ref<'min' | 'max' | null>(null)


const minInputValue = ref<number | null>(props.filterData.min.toFixed(2));
const maxInputValue = ref<number | null>(props.filterData.max.toFixed(2));
const unit = ref(props.filterData.unit)

const handleMinInputChange = (event: Event) => {
  if (Number(event.target.value) < Number(minInputValue.value)) {
    minError.value = true
    minErrorText.value = `Minimalna wartość to: ${minInputValue.value}`
    return;
  }
  if (Number(event.target.value) > Number(maxInputValue.value)) {
    minError.value = true
    minErrorText.value = `Maksymalna wartość to: ${maxInputValue.value}`
    return
  }
  clearMinErrors()
  filtersStore.updateRangeValue(event, props.field, props.filterData, event.target.value, maxValue.value);
  inputChanging.value = 'min'
  emit('closeDropdown');
}


const handleMaxInputChange = (event: Event) => {
  if (Number(event.target.value) <= Number(minInputValue.value)) {
    maxError.value = true
    maxErrorText.value = `Minimalna wartość to: ${minInputValue.value}`
    return
  }
  clearMaxErrors()
  filtersStore.updateRangeValue(event, props.field, props.filterData, minValue.value, event.target.value);
  inputChanging.value = 'max'
  emit('closeDropdown');
}
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!
const clearMinErrors = () => {
  minError.value = false
  minErrorText.value = ''
}

const clearMaxErrors = () => {
  maxError.value = false
  maxErrorText.value = ''
}
const clearErrors = () => {
  clearMinErrors()
  clearMaxErrors()

}
onMounted(() => {
  setTimeout(() => {
    clearErrors('onMounted')
    if (getActiveFilters.value[props.field]) {
      minValue.value = getActiveFilters.value[props.field].min
      maxValue.value = getActiveFilters.value[props.field].max
    }
  }, 500)


})
onUpdated(()=>{
  const {min, max} = props.filterData
  minInputValue.value = min.toFixed(2)
  maxInputValue.value = max.toFixed(2)
})

watch(getActiveFilters, () => {
  clearErrors('onWatch')

  if (getActiveFilters.value[props.field]) {
    if (inputChanging.value === 'min') {
      minValue.value = getActiveFilters.value[props.field].min
    }
    if (inputChanging.value === 'max') {
      maxValue.value = getActiveFilters.value[props.field].max
    }
  } else {
    minValue.value = null
    maxValue.value = null
  }
}, {immediate: false});


</script>

<style>
/* Chrome, Safari, Edge, Opera */
#smartsearch-serp input::-webkit-outer-spin-button,
#smartsearch-serp input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
#smartsearch-serp input[type=number] {
  -moz-appearance: textfield;
}
.q-unit {
  background-color: #fff;
  border-left: none;
  border-radius: 0 0.5em 0.5em 0 !important;
}

.q-with-unit {
  border-radius: 0.5em 0 0 0.5em !important;
  border-right: none;
}

.q-input-group-sm .q-form-control:focus {
  /*border: 1px solid #dee2e6 !important;*/
  outline: 0;
  box-shadow: none !important;
}

.filter__item-container-rangeSlider {
  min-height: 80px;
}

.q-error-message {
  font-size: 9px;
  color: red;
  bottom: -14px;
  text-wrap: nowrap;
}

.q-with-error .q-form-control {
  border-color: red !important;
}

.q-with-error .q-input-group-text.q-unit {
  border-color: red;
}

.q-form-control:focus ~ .q-input-group-text {
  border-color: #86b7fe;
}
.q-with-error .q-form-control:focus ~ .q-input-group-text {
  border-color: red;
}
</style>
